import "bootstrap/js/src/offcanvas";
import "bootstrap/js/src/collapse";

import {Carousel} from "./components/Carousel";
import {VideoPlayer} from "./components/VideoPlayer";

document.addEventListener("DOMContentLoaded", () => {
    const toggleClassButtons = document.querySelectorAll("button[data-toggle-target]");

    if (toggleClassButtons) {
        toggleClassButtons.forEach((button: HTMLButtonElement) => {
            button.addEventListener("click", () => {
                const targetSelector = button.dataset.toggleTarget;

                if (!targetSelector) return;

                const targetEl = document.querySelector<HTMLElement>(targetSelector);
                console.log(targetEl)
                if (!targetEl || !targetEl.dataset.toggleClass) return;
                console.log(targetEl, targetEl.dataset.toggleClass);
                targetEl.classList.toggle(targetEl.dataset.toggleClass);
            });
        });
    }

    const reviewsSliderEl = document.querySelector<HTMLElement>("#reviewsSlider");

    if (reviewsSliderEl) {
        new Carousel(reviewsSliderEl, {
            prevButton: document.querySelector("#reviewsSliderPrev"),
            nextButton: document.querySelector("#reviewsSliderNext"),
            showDots: false
        });
    }

    const monitoringSliderEl = document.querySelector<HTMLElement>("#monitoringSlider");

    if (monitoringSliderEl) {
        new Carousel(monitoringSliderEl, {
            prevButton: document.querySelector("#monitoringSliderPrev"),
            nextButton: document.querySelector("#monitoringSliderNext"),
            showDots: true,
            dotsContainer: document.querySelector("#monitoringSliderDots")
        })
    }

    // const serviceItems = document.querySelectorAll<HTMLElement>(".js-monthly-service-item");
    //
    // if (serviceItems) {
    //     serviceItems.forEach((item) => {
    //         const expandButtons = item.querySelectorAll(".js-expand-button");
    //
    //         if (!expandButtons) return;
    //
    //         expandButtons.forEach((button) => {
    //             button.addEventListener("click", () => {
    //                 item.classList.toggle("is-active");
    //             });
    //         })
    //     });
    // }

    const videos = document.querySelectorAll<HTMLElement>(".js-video");

    if (videos) {
        videos.forEach((video) => {
            new VideoPlayer(video);
        });
    }
});